const autoCompleteDisabled = process.env.REACT_APP_FORM_AUTOCOMPLETE === 'off';

export function autoCompleteIfEnabled(autoComplete?: string): string | undefined {
  return autoCompleteDisabled ? 'off' : autoComplete;
}
